import React from "react";
import { ArrowLeftIcon } from "@heroicons/react/24/solid";
import Button from "../componentLibrary/Button";
import { PageI, ModuleI, LessonI } from "../types";
import AddToToolboxButton from "./AddToToolboxButton";
import GoToToolboxButton from "./GoToToolboxButton";

interface LessonBottomNavigationProps {
  currentPage: number;
  currentPageData: PageI;
  module: ModuleI;
  lesson: LessonI;
  onPageChange: (direction: "next" | "back") => void;
  onToolboxClick: () => void;
  onBeforeNavigateToToolbox?: () => void | Promise<void>;
  hasToolboxContent: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  answers?: Record<string, any>;
}

const LessonBottomNavigation: React.FC<LessonBottomNavigationProps> = ({
  currentPageData,
  module,
  lesson,
  onPageChange,
  onToolboxClick,
  onBeforeNavigateToToolbox,
  hasToolboxContent,
  answers,
}) => {
  return (
    <div className="w-full bg-white border-t border-gray-200 shadow-md">
      <div className="w-full max-w-none px-4 pt-4 pb-8 mb-6">
        <div className="flex items-center justify-center gap-3 max-w-md mx-auto">
          {/* Back Button */}
          <Button.Circle
            variant="primary"
            onClick={() => onPageChange("back")}
            className="h-10 w-10 flex items-center justify-center flex-shrink-0"
          >
            <ArrowLeftIcon className="h-5 w-5" />
          </Button.Circle>

          <div className="flex-shrink-0">
            <AddToToolboxButton
              page={currentPageData}
              module={module}
              lesson={lesson}
              tutorialPosition="top"
              answers={answers}
              onBeforeNavigate={onBeforeNavigateToToolbox}
            />
          </div>

          {/* Go To Toolbox Button - only show if toolbox has content */}
          {hasToolboxContent && (
            <div className="flex-shrink-0">
              <GoToToolboxButton onClick={onToolboxClick} />
            </div>
          )}

          {/* Next Button */}
          <Button.Circle
            variant="primary"
            onClick={() => onPageChange("next")}
            className="h-10 w-10 flex items-center justify-center flex-shrink-0"
          >
            <ArrowLeftIcon className="h-5 w-5 transform rotate-180" />
          </Button.Circle>
        </div>
      </div>
    </div>
  );
};

export default LessonBottomNavigation;
